<ng-container [ngTemplateOutlet]="tab?.pageBreadcrumb"></ng-container>
<div class="m-2">
    <tab-head #tab [loading]="loadingData" [segment]="{BASIC:'Basic',EDUCATION : 'Education',PHYSICAL:'Physical'}">
    <ng-template #tabBody let-active="activeKey">
        <div [hidden]="active!='BASIC'">
            <div class="row text-center" *ngIf="!loadingData">
                <div class="col-lg-4 col-md-12 col-xl-4">
                    <profile-widget [profileData]="childData" type="CHILD"></profile-widget>
                </div>
                <div class="col-lg-8 col-md-8 col-xl-8">
                    <info-view [sourceData]="childData" [formData]="showData" direction="VERTICAL"></info-view>
                </div>
            </div>
        </div>
        <div [hidden]="active!='EDUCATION'">
            <app-staff-education #childEdu [config]="{type : 'CHILD',isView:true}"
                [sourceData]="childData?.education"></app-staff-education>
        </div>
        <div [hidden]="active!='PHYSICAL'">
            <info-view [sourceData]="childData?.physical" [formData]="childPhyForm" direction="VERTICAL"></info-view>
        </div>
    </ng-template>
</tab-head>
</div>
<app-page-loader [loading]="loadingData"></app-page-loader>